<template>
  <div class="h-100">
    <common ref="common" />
    <template v-if="receiptList.length">
      <v-row class="ma-0 pt-2">
        <v-col cols="12" class="py-1">
          <v-select
            v-model="schemes"
            multiple
            :items="schemeList"
            label=""
            item-text="schemeName"
            item-value="id"
            dense
            outlined
            hide-details
            :menu-props="{ bottom: true, offsetY: true }"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index == 0" x-small>
                <span>{{ item.schemeName }}</span>
              </v-chip>
              <span v-if="index == 1" class="grey--text text-caption">
                (+{{ schemes.length - 1 }} others)
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row class="pt-1 ma-0">
        <v-col style="overflow: auto;">
          <v-card
            v-for="(sub, index) in receiptList"
            v-bind:key="index"
            class="mx-auto rounded-xl mb-2 ma-1"
            :elevation="$vuetify.theme.dark ? 24 : 5"
            max-width="100%"
          >
            <v-row no-gutters class="pt-1 pb-0 ma-0">
              <v-col cols="7">
                <v-card-subtitle class="font-weight-bold">
                  {{ sub.number }}
                </v-card-subtitle>
              </v-col>
              <v-col cols="5">
                <v-card-subtitle class="text-right font-weight-bold">
                  {{ formatDate(sub.date) }}
                </v-card-subtitle>
              </v-col>
            </v-row>
            <v-card-actions class="pt-0 pb-0">
              <v-btn
                color="green"
                text
                rounded
                x-large
                @click="getDetails(sub.id)"
              >
                ₹
                {{ formatNumber(sub.receivedAmount) }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="downloadReceipt(sub)">
                <v-icon class="large material-icons icon-blue" color="#ff4500"
                  >mdi-file-pdf</v-icon
                >
              </v-btn>
              <v-btn icon @click="getDetails(sub.id)">
                <v-icon>mdi-arrow-expand-all</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
        transition="dialog-transition"
        v-model="showDetail"
        @keydown.esc="showDetail = false"
        persistent
        scrollable
      >
        <v-card class="rounded-xl" elevation="24">
          <v-card-title>
            <label>Receipt Details</label>
            <v-spacer></v-spacer>
            <v-btn icon @click="showDetail = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="ColumnContainer" v-if="receiptDetailList.length > 0">
              <v-simple-table
                :dense="false"
                :fixed-header="true"
                :height="450"
                class="overflow-y-auto hst-table"
                max-height="calc(90vh - 520px)"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                       <th class="text-right">Amount</th>
                      <th class="text-left">Due Date</th>
                      <th class="text-left">Scheme</th>
                      <th class="text-left">Due No</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in receiptDetailList" :key="item.id">
                      <td class="text-right">
                        {{ formatNumber(item.amount) }}
                      </td>
                      <td class="text-left">{{ formatDate(item.invoiceDate) }}</td>
                      <td class="text-left">{{ item.schemeName }}</td>
                      <td class="text-left">{{ item.invoiceNumber }}</td>
                      
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div v-else class="d-flex align-content-start flex-wrap pt-15">
              <v-img
                src="../../../../assets/unauthorized.svg"
                :aspect-ratio="1.9"
                contain
              >
              </v-img>
              <div
                class="text-center title-style pt-10 mx-auto"
                style="padding-bottom: 150px !important"
              >
                No Data Found
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <div v-else class="h-100 d-flex align-center justify-center">
      <div class="d-flex flex-column align-center justify-center">
      <v-img
            src="@/assets/undraw_ideas_re_7twj.svg"
            height="150"
            width="150"
            contain
          />
          <p class="mt-4 text-center">Hi {{$store.getters.name}}, you have no history with existing schemes.</p>
        </div>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import dayjs from "dayjs";
import Vue from "vue";
import VueEvents from "vue-events";
import common from "@/components/tools/common";
import { getLoginType } from "@/utils/auth";
import { callApi } from "@/api/others";
Vue.use(VueEvents);
export default {
  components: { common },
  props: {},
  data() {
    return {
      receiptDetailShow: false,
      schemes: [],
      showDetail: false,
      receiptList: [],
      receiptDetailList: [],
      schemeList: [],
    };
  },
  created() {
    this.type = getLoginType();
  },
  mounted() {
    this.$emit("changeHeader", "History");
    this.getreceiptList();
    this.getSchemes();
  },
  watch: {},
  computed: {},
  methods: {
    async downloadReceipt(model){
      this.dpLoading = true;
      let url = `/api/wesupport/Receipt/print`;
      await callApi(url,"post",model,"blob")
      .then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = model.number + ".pdf";
        document.body.appendChild(link);
        link.click();
      })
      .catch((err)=>{
        console.log(err);
        this.$refs.common.ManageResponse(err.response);
      })
      .finally(()=>{
        this.dpLoading = false;
      });
    },
    getDetails(id) {
      var common = this.$refs.common;
      var url = "/api/wesupport/Receipt/getReceiptDetailById?id=" + id;
      callApi(url, "get", "")
        .then((response) => {
          this.receiptDetailList = response.data.data;
          this.showDetail = true;
        })
        .catch((error) => {
          this.showDetail = false;
          common.ManageResponse(error.response);
        });
    },
    async getSchemes() {
      var common = this.$refs.common;
      var url = "/api/wesupport/Scheme/getAutoComplete";
      await callApi(url, "get", "")
        .then((response) => {
          this.schemeList = response.data.data;
          if (this.schemeList.length > 0) {
            this.schemeList.forEach((x) => this.schemes.push(x.id));
          }
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
    async getreceiptList() {
      var common = this.$refs.common;
      var url = `/api/wesupport/Receipt/getMemberReceiptList?memberId=${this.decryptMemId()}`;
      await callApi(url, "get", "")
        .then((response) => {
          this.receiptList = response.data.data;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
    async getLoggeduser() {
      var common = this.$refs.common;
      let url = "/api/wesupport/Member/getUserDetails";
      await callApi(url, "post", "")
        .then((res) => {
          if (res) {
            this.loggedUserId = res.data.data;
          }
        })
        .catch((err) => {
          common.ManageResponse(err.response);
        });
    },
    formatDate(d) {
      return dayjs(d).format("DD-MM-YYYY");
    },
  },
};
</script>
<style scoped>
.v-autocomplete__content .v-list__tile {
  height: auto;
}

.scroll {
  writing-mode: horizontal-tb;
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-top: 0px;
  padding-left: 0px;
}

.alignAdd {
  margin-left: 143px;
}

.v-icon.outlined_error {
  border: 1px solid #ff5252;
  border-radius: 100%;
  height: 50px;
  width: 40px;
}

.v-icon.outlined_success {
  border: 1px solid #4caf50;
  border-radius: 100%;
  height: 50px;
  width: 40px;
}
</style>
<style>
.hst-table td,
.hst-table th {
  white-space: nowrap;
  padding-inline: 10px !important;
  height: 35px !important;
}
</style>
